import * as api from "../api/index";

import {
  ADD_NEW,
  UPDATE,
  DELETE,
  GET_INVOICE,
  FETCH_INVOICE_BY_USER,
  FETCH_ALL,
  START_LOADING,
  END_LOADING,
  FETCH_PAGE,
} from "./constants";

export const getInvoices = () => async (dispatch) => {
  try {
    dispatch({ type: START_LOADING });
    const { data } = await api.fetchInvoices();
    console.log(data);
    dispatch({ type: FETCH_ALL, payload: data });
    dispatch({ type: END_LOADING });
  } catch (error) {
    console.log(error);
  }
};
export const getInvoicesByPage = (page, limit, startDate, endDate, salesperson, party, searchQuery, selectedFilter) => async (dispatch) => {
  try {
    // debugger
    dispatch({ type: START_LOADING });
    const { data } = await api.fetchInvoicesByPage(page, limit, startDate, endDate, salesperson, party, searchQuery, selectedFilter);
    console.log(data);
    dispatch({ type: FETCH_PAGE, payload: data });
    dispatch({ type: END_LOADING });
  } catch (error) {
    console.log(error);
  }
};

export const getAllInvoicesWithFilters = (startDate, endDate, salesperson, party, searchQuery, selectedFilter) => async () => {
  try {
    const { data } = await api.fetchAllInvoicesWithFilters(startDate, endDate, salesperson, party, searchQuery, selectedFilter);
    return data;
  } catch (error) {
    console.log(error);
    throw error;
  }
};
export const getInvoicesByUser = (searchQuery) => async (dispatch) => {
  try {
    dispatch({ type: START_LOADING });
    const {
      data: { data },
    } = await api.fetchInvoicesByUser(searchQuery);
    dispatch({ type: FETCH_INVOICE_BY_USER, payload: data });
    dispatch({ type: END_LOADING });
  } catch (error) {
    console.log(error.response);
  }
};

export const getInvoicesByClient = (clientId) => async (dispatch) => {
  try {
    dispatch({ type: START_LOADING });
    const { data } = await api.fetchInvoicesByClient(clientId);
    console.log("Invoices by client:", data);
    dispatch({ type: FETCH_ALL, payload: data });
    dispatch({ type: END_LOADING });
  } catch (error) {
    console.log(error);
  }
};

export const getInvoice = (id) => async (dispatch) => {
  const user = JSON.parse(localStorage.getItem("profile"));

  try {
    const { data } = await api.fetchInvoice(id);
    // console.log("getInvoicedata",data)
    const businessDetails = await api.fetchProfilesByUser(user.result._id);
    // console.log("Business Details: " ,businessDetails)
    const invoiceData = { ...data, businessDetails };

    // console.log("invoice Data",invoiceData)
    dispatch({ type: GET_INVOICE, payload: invoiceData });
  } catch (error) {
    console.log(error.response);
  }
};

export const createInvoice = (invoice, history) => async (dispatch) => {
  try {
    console.log("Create Invoice Called");
    dispatch({ type: START_LOADING });
    const { data } = await api.addInvoice(invoice);
    console.log("Created Invoice Data", data);
    dispatch({ type: ADD_NEW, payload: data });
    history.push(`/invoice/${data._id}`);
    dispatch({ type: END_LOADING });
  } catch (error) {
    console.log(error);
  }
};

// export const groupInvoiceDownload =
//   (filterData, openSnackbar, setLoading) => async (dispatch) => {
//     try {
//       setLoading(true);

//       const { data } = await api.groupInvoiceDownload(filterData);

//       const blob = new Blob([data], {
//         type: "application/zip",
//       });

//       const url = window.URL.createObjectURL(blob);

//       const link = document.createElement("a");
//       link.href = url;
//       link.download = `Invoices_${filterData.fromDate}_to_${filterData.toDate}.zip`;

//       document.body.appendChild(link);
//       link.click();

//       link.remove();
//       window.URL.revokeObjectURL(url);

//       openSnackbar("Invoices downloaded successfully");
//     } catch (error) {
//       console.error("Group invoice download failed", error);
//       openSnackbar("Invoice download failed");
//     } finally {
//       setLoading(false); // ✅ loader stops at correct time
//     }
//   };

export const groupInvoiceDownload =
  (filterData, openSnackbar, setLoading) => async () => {
    try {
      console.log("Group Invoice Download Called");


      const { data } = await api.groupInvoiceDownload(filterData);

      const blob = new Blob([data], {
        type: "application/zip",
      });

      const url = window.URL.createObjectURL(blob);

      const link = document.createElement("a");
      link.href = url;
      link.download = `Invoices_${filterData.fromDate}_to_${filterData.toDate}.zip`;

      document.body.appendChild(link);
      link.click();

      link.remove();
      window.URL.revokeObjectURL(url);

      openSnackbar("Invoices downloaded successfully");

  
    } catch (error) {
      console.error("Group invoice download failed", error);

      if (error.response?.data) {
        const reader = new FileReader();
        reader.onload = () => {
          try {
            const err = JSON.parse(reader.result);
            openSnackbar(err.message);
          } catch {
            openSnackbar("Invoice download failed");
          }
        };
        reader.readAsText(error.response.data);
      } else {
        openSnackbar("Network error. Please try again.");
      }
    } finally {
      setLoading(false);
    }
  };


export const updateInvoice = (id, invoice) => async (dispatch) => {
  try {
    const { data } = await api.updateInvoice(id, invoice);
    dispatch({ type: UPDATE, payload: data });
  } catch (error) {
    console.log(error);
  }
};

export const deleteInvoice = (id, openSnackbar) => async (dispatch) => {
  try {
    await api.deleteInvoice(id);

    dispatch({ type: DELETE, payload: id });
    openSnackbar("Order deleted successfully");
  } catch (error) {
    console.log(error.response);
  }
};
